(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/media-loader
 * -----------------------------------------------------------------------------
 * @version 0.0.7
 * @overview Click-to-load embedded media content.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("media-loader") === undefined) {
    class MediaLoader extends HTMLElement {
        constructor(){
            super();
            this.button = this.querySelector("button");
            if (!this.button) return;
            this.button.addEventListener("click", this.clickEvent.bind(this), false);
        }
        clickEvent(event) {
            event.preventDefault();
            this.loadMedia();
            this.button.hidden = true;
            document.querySelectorAll("media-loader").forEach((MediaLoader)=>{
                if (MediaLoader === this) return;
                this.unloadMedia(MediaLoader);
            });
        }
        loadMedia() {
            if (!this.querySelector("template")) return;
            this.media = this.querySelector("template").content.firstElementChild.cloneNode(true);
            this.media.classList.add("media-loader-media");
            this.appendChild(this.media);
            this.querySelector("audio, canvas, embed, iframe, model-viewer, object, video")[0]?.focus();
        }
        unloadMedia(player) {
            player.querySelector(".media-loader-media")?.remove();
            player.querySelector("button").hidden = false;
        }
    }
    customElements.define("media-loader", MediaLoader);
}



})();
